<template>
	<div>
    <side-bar icon="event" title="Select events" search v-model="search">
      <template #buttons>
        <k-btn icon icon-name="restart_alt" no-margin size="xs" v-tooltip.bottom="'Reset layout'" @click="reset_layout"></k-btn>
        <k-btn v-if="$is_admin()" icon icon-name="filter" no-margin size="xs" @click="add_own_todo_events"></k-btn>
      </template>

      <template #default>
        <k-list bordered :items="filtered_events" @click="toggleEventFilter" two-line>
          <template #left="{ item }">
            <k-icon small color="success" v-if="is_running(item)">circle</k-icon>
            <k-icon small color="primary" v-else>circle</k-icon>
          </template>
          <template #default="{ item }">
            {{name(item)}}
          </template>
          <template #subtitle="{ item }">
            {{time(item)}}
          </template>
          <template #right="{ item }">
            <k-icon size="m" v-if="is_visible(item)" color="accent">visibility</k-icon>
            <k-icon size="m" v-if="!is_visible(item)">visibility_off</k-icon>
          </template>
        </k-list>
      </template>
    </side-bar>
  </div>
</template>

<script>
import datelib from '@/lib/date.js';
import moment from 'moment';
import EventModel from '@/models/event.js'
import SideBar from '@/components/SideBar.vue'

export default {
  components: {
    SideBar
  },
	data () {
    var start_date = moment().startOf('day').toDate();
    var end_date = moment().endOf('day').toDate();
		return {
      channel: undefined,
      events: [],
      filters: {
        daterange: {
          start: start_date,
          end: end_date
        },
        states: ["active"]
      },
      ts: this.$store.state.timestamp,
      on_init_ref: undefined,
      on_events_ref: undefined,
      on_event_update_ref: undefined,
      search: ""
		}
	},
  computed: {
    filtered_events() {
      if(this.search.length < 1) {
        return _.sortBy(this.events, function(o) { return [o.cached_start_time] });
      }
      return _.sortBy(_.filter(this.events, (event) => {
        return this.name(event).toLowerCase().includes(this.search.toLowerCase());
      }), function(o) { return [o.cached_start_time] })
    },
		multiview_filters () {
			return this.$store.state.account.meta.multiview_event_filter || [];
		}
  },
  methods: {
    reset_layout() {
      localStorage.removeItem("kvideogrid:" + (this.$store.state.account.id || "") + ":multiview");
      window.location.reload();
    },
    is_running(e) {
      console.log("is_running");
      return EventModel.is_current(e);
      return e.cached_start_time <= this.ts && e.cached_end_time >= this.ts;
    },
    name(event) {
      return EventModel.title(event);
    },
    time(event) {
      return this.format_date(event.cached_start_time)
    },
    is_visible(event) {
      return typeof(_.find(this.multiview_filters, (uuid) => { return uuid == event.uuid; })) != "undefined";
    },
    format_date (v) {
      return datelib.format_date(v) + " - " + datelib.format_time(v);
    },
    filterEvents () {
      var _filters = _.cloneDeep(this.filters);
      if(typeof(_filters.daterange.start) != "undefined") {
        _filters.daterange.start = moment(_filters.daterange.start).startOf('day').unix();
      }
      if(typeof(_filters.daterange.end) != "undefined") {
        _filters.daterange.end = moment(_filters.daterange.end).endOf('day').unix();
      }
      this.channel.push("filter", _filters);
    },
    add_own_todo_events() {
      var self = this;
      var acc = _.cloneDeep(this.$store.state.account);
      _.each(this.events, function(event) {
        if (EventModel.is_todo_list(event, acc) == true) {
          console.log(event.event_group);
          acc.meta.multiview_event_filter.push(event.uuid);
        }
      });
      acc.meta.multiview_event_filter = _.uniq(acc.meta.multiview_event_filter);
      this.$store.dispatch("update_profile", acc);      
    },
    toggleEventFilter(event) {
      console.log("ToGGLE FILTEr", event);
			var acc = _.cloneDeep(this.$store.state.account);
			acc.meta.multiview_event_filter = _.xor(acc.meta.multiview_event_filter, [event.uuid]);
			this.$store.dispatch("update_profile", acc);
    },
    connect_ws () {
      var self = this;
      this.channel = this.$cloudserver.channel("events:all", false);
      this.on_init_ref = this.channel.on("init", function(msg) {
        self.filterEvents();
      });
      this.on_events_ref = this.channel.on("events", function(msg) {
        self.ts = self.$store.state.timestamp;
        self.events = msg.events;
				self.$store.dispatch("get_profile").then(() => {
					var acc = _.cloneDeep(self.$store.state.account);
					var uuids = _.map(self.events, "uuid");
	        acc.meta.multiview_event_filter = _.filter(acc.meta.multiview_event_filter, (filter) => { return uuids.indexOf(filter) != -1; });
					self.$store.dispatch("update_profile", acc);
				}, () => {});
      });
      this.on_event_update_ref = this.channel.on("event-update", function(msg) {
        self.filterEvents();
      });
      this.channel.join();
    }
  },
  mounted () {
		this.$store.dispatch("get_profile").then(() => {
	    this.$nextTick(() => {
	      this.connect_ws();
	    });
		}, () => {});
    var self = this;
    self.ts = self.$store.state.timestamp || moment().unix();
    this.interval = setInterval(() => {
      self.ts = self.$store.state.timestamp;
    },10000);
  }
}
</script>
